//# sourceMappingURL=toast.mjs.map
/// <reference types="./toast.d.mts" />
import * as $option from "../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../gleam_stdlib/gleam/option.mjs";
import * as $redraw from "../../redraw/redraw.mjs";
import { CustomType as $CustomType } from "../gleam.mjs";
import * as $options from "../redraw_toastify/internal/options.mjs";
import {
  toast,
  custom,
  dismiss,
  dismiss as clear,
  isActive as is_active,
  update,
  clearWaitingQueue as clear_waiting_queue,
  done,
  play,
  pause,
} from "./toast.ffi.mjs";

export {
  clear,
  clear_waiting_queue,
  custom,
  dismiss,
  done,
  is_active,
  pause,
  play,
  toast,
  update,
};

export class Info extends $CustomType {}
export const Type$Info = () => new Info();
export const Type$isInfo = (value) => value instanceof Info;

export class Success extends $CustomType {}
export const Type$Success = () => new Success();
export const Type$isSuccess = (value) => value instanceof Success;

export class Warning extends $CustomType {}
export const Type$Warning = () => new Warning();
export const Type$isWarning = (value) => value instanceof Warning;

export class Error extends $CustomType {}
export const Type$Error = () => new Error();
export const Type$isError = (value) => value instanceof Error;

export class TopRight extends $CustomType {}
export const Position$TopRight = () => new TopRight();
export const Position$isTopRight = (value) => value instanceof TopRight;

export class TopCenter extends $CustomType {}
export const Position$TopCenter = () => new TopCenter();
export const Position$isTopCenter = (value) => value instanceof TopCenter;

export class TopLeft extends $CustomType {}
export const Position$TopLeft = () => new TopLeft();
export const Position$isTopLeft = (value) => value instanceof TopLeft;

export class BottomRight extends $CustomType {}
export const Position$BottomRight = () => new BottomRight();
export const Position$isBottomRight = (value) => value instanceof BottomRight;

export class BottomCenter extends $CustomType {}
export const Position$BottomCenter = () => new BottomCenter();
export const Position$isBottomCenter = (value) => value instanceof BottomCenter;

export class BottomLeft extends $CustomType {}
export const Position$BottomLeft = () => new BottomLeft();
export const Position$isBottomLeft = (value) => value instanceof BottomLeft;

class Options extends $CustomType {
  constructor(toast_id, type_, position, on_open, on_close, auto_close, close_button, transition, hide_progress_bar, pause_on_hover, pause_on_focus_loss, close_on_click, class_name, style, progress_class_name, draggable, draggable_percent, draggable_direction, container_id, role, delay, on_click, render, is_loading) {
    super();
    this.toast_id = toast_id;
    this.type_ = type_;
    this.position = position;
    this.on_open = on_open;
    this.on_close = on_close;
    this.auto_close = auto_close;
    this.close_button = close_button;
    this.transition = transition;
    this.hide_progress_bar = hide_progress_bar;
    this.pause_on_hover = pause_on_hover;
    this.pause_on_focus_loss = pause_on_focus_loss;
    this.close_on_click = close_on_click;
    this.class_name = class_name;
    this.style = style;
    this.progress_class_name = progress_class_name;
    this.draggable = draggable;
    this.draggable_percent = draggable_percent;
    this.draggable_direction = draggable_direction;
    this.container_id = container_id;
    this.role = role;
    this.delay = delay;
    this.on_click = on_click;
    this.render = render;
    this.is_loading = is_loading;
  }
}

export function type_(options, type_) {
  let type_$1 = new Some(type_);
  return new Options(
    options.toast_id,
    type_$1,
    options.position,
    options.on_open,
    options.on_close,
    options.auto_close,
    options.close_button,
    options.transition,
    options.hide_progress_bar,
    options.pause_on_hover,
    options.pause_on_focus_loss,
    options.close_on_click,
    options.class_name,
    options.style,
    options.progress_class_name,
    options.draggable,
    options.draggable_percent,
    options.draggable_direction,
    options.container_id,
    options.role,
    options.delay,
    options.on_click,
    options.render,
    options.is_loading,
  );
}

export function default_options() {
  return new Options(
    new None(),
    new None(),
    new None(),
    new None(),
    new None(),
    new None(),
    new None(),
    new None(),
    new None(),
    new None(),
    new None(),
    new None(),
    new None(),
    new None(),
    new None(),
    new None(),
    new None(),
    new None(),
    new None(),
    new None(),
    new None(),
    new None(),
    new None(),
    new None(),
  );
}

export function success(content) {
  let _pipe = default_options();
  let _pipe$1 = type_(_pipe, new Success());
  return custom(_pipe$1, content);
}

export function info(content) {
  let _pipe = default_options();
  let _pipe$1 = type_(_pipe, new Info());
  return custom(_pipe$1, content);
}

export function warning(content) {
  let _pipe = default_options();
  let _pipe$1 = type_(_pipe, new Warning());
  return custom(_pipe$1, content);
}

export function error(content) {
  let _pipe = default_options();
  let _pipe$1 = type_(_pipe, new Error());
  return custom(_pipe$1, content);
}

export function toast_id(options, toast_id) {
  let toast_id$1 = new Some(toast_id);
  return new Options(
    toast_id$1,
    options.type_,
    options.position,
    options.on_open,
    options.on_close,
    options.auto_close,
    options.close_button,
    options.transition,
    options.hide_progress_bar,
    options.pause_on_hover,
    options.pause_on_focus_loss,
    options.close_on_click,
    options.class_name,
    options.style,
    options.progress_class_name,
    options.draggable,
    options.draggable_percent,
    options.draggable_direction,
    options.container_id,
    options.role,
    options.delay,
    options.on_click,
    options.render,
    options.is_loading,
  );
}

export function position(options, position) {
  let position$1 = new Some(position);
  return new Options(
    options.toast_id,
    options.type_,
    position$1,
    options.on_open,
    options.on_close,
    options.auto_close,
    options.close_button,
    options.transition,
    options.hide_progress_bar,
    options.pause_on_hover,
    options.pause_on_focus_loss,
    options.close_on_click,
    options.class_name,
    options.style,
    options.progress_class_name,
    options.draggable,
    options.draggable_percent,
    options.draggable_direction,
    options.container_id,
    options.role,
    options.delay,
    options.on_click,
    options.render,
    options.is_loading,
  );
}

export function on_open(options, on_open) {
  let on_open$1 = new Some(on_open);
  return new Options(
    options.toast_id,
    options.type_,
    options.position,
    on_open$1,
    options.on_close,
    options.auto_close,
    options.close_button,
    options.transition,
    options.hide_progress_bar,
    options.pause_on_hover,
    options.pause_on_focus_loss,
    options.close_on_click,
    options.class_name,
    options.style,
    options.progress_class_name,
    options.draggable,
    options.draggable_percent,
    options.draggable_direction,
    options.container_id,
    options.role,
    options.delay,
    options.on_click,
    options.render,
    options.is_loading,
  );
}

export function on_close(options, on_close) {
  let on_close$1 = new Some(on_close);
  return new Options(
    options.toast_id,
    options.type_,
    options.position,
    options.on_open,
    on_close$1,
    options.auto_close,
    options.close_button,
    options.transition,
    options.hide_progress_bar,
    options.pause_on_hover,
    options.pause_on_focus_loss,
    options.close_on_click,
    options.class_name,
    options.style,
    options.progress_class_name,
    options.draggable,
    options.draggable_percent,
    options.draggable_direction,
    options.container_id,
    options.role,
    options.delay,
    options.on_click,
    options.render,
    options.is_loading,
  );
}

export function auto_close(options) {
  let auto_close$1 = new Some(new $options.AutocloseBool(true));
  return new Options(
    options.toast_id,
    options.type_,
    options.position,
    options.on_open,
    options.on_close,
    auto_close$1,
    options.close_button,
    options.transition,
    options.hide_progress_bar,
    options.pause_on_hover,
    options.pause_on_focus_loss,
    options.close_on_click,
    options.class_name,
    options.style,
    options.progress_class_name,
    options.draggable,
    options.draggable_percent,
    options.draggable_direction,
    options.container_id,
    options.role,
    options.delay,
    options.on_click,
    options.render,
    options.is_loading,
  );
}

export function auto_close_after(options, timeout) {
  let auto_close$1 = new Some(new $options.AutocloseTimeout(timeout));
  return new Options(
    options.toast_id,
    options.type_,
    options.position,
    options.on_open,
    options.on_close,
    auto_close$1,
    options.close_button,
    options.transition,
    options.hide_progress_bar,
    options.pause_on_hover,
    options.pause_on_focus_loss,
    options.close_on_click,
    options.class_name,
    options.style,
    options.progress_class_name,
    options.draggable,
    options.draggable_percent,
    options.draggable_direction,
    options.container_id,
    options.role,
    options.delay,
    options.on_click,
    options.render,
    options.is_loading,
  );
}

export function close_manually(options) {
  let auto_close$1 = new Some(new $options.AutocloseBool(false));
  return new Options(
    options.toast_id,
    options.type_,
    options.position,
    options.on_open,
    options.on_close,
    auto_close$1,
    options.close_button,
    options.transition,
    options.hide_progress_bar,
    options.pause_on_hover,
    options.pause_on_focus_loss,
    options.close_on_click,
    options.class_name,
    options.style,
    options.progress_class_name,
    options.draggable,
    options.draggable_percent,
    options.draggable_direction,
    options.container_id,
    options.role,
    options.delay,
    options.on_click,
    options.render,
    options.is_loading,
  );
}

export function hide_close_button(options) {
  let close_button = new Some(new $options.CloseButtonBool(false));
  return new Options(
    options.toast_id,
    options.type_,
    options.position,
    options.on_open,
    options.on_close,
    options.auto_close,
    close_button,
    options.transition,
    options.hide_progress_bar,
    options.pause_on_hover,
    options.pause_on_focus_loss,
    options.close_on_click,
    options.class_name,
    options.style,
    options.progress_class_name,
    options.draggable,
    options.draggable_percent,
    options.draggable_direction,
    options.container_id,
    options.role,
    options.delay,
    options.on_click,
    options.render,
    options.is_loading,
  );
}

export function show_close_button(options) {
  let close_button = new Some(new $options.CloseButtonBool(true));
  return new Options(
    options.toast_id,
    options.type_,
    options.position,
    options.on_open,
    options.on_close,
    options.auto_close,
    close_button,
    options.transition,
    options.hide_progress_bar,
    options.pause_on_hover,
    options.pause_on_focus_loss,
    options.close_on_click,
    options.class_name,
    options.style,
    options.progress_class_name,
    options.draggable,
    options.draggable_percent,
    options.draggable_direction,
    options.container_id,
    options.role,
    options.delay,
    options.on_click,
    options.render,
    options.is_loading,
  );
}

export function custom_close_button(options, component) {
  let close_button = new Some(new $options.CloseButtonNode(component));
  return new Options(
    options.toast_id,
    options.type_,
    options.position,
    options.on_open,
    options.on_close,
    options.auto_close,
    close_button,
    options.transition,
    options.hide_progress_bar,
    options.pause_on_hover,
    options.pause_on_focus_loss,
    options.close_on_click,
    options.class_name,
    options.style,
    options.progress_class_name,
    options.draggable,
    options.draggable_percent,
    options.draggable_direction,
    options.container_id,
    options.role,
    options.delay,
    options.on_click,
    options.render,
    options.is_loading,
  );
}

export function transition(options, transition) {
  let transition$1 = new Some(transition);
  return new Options(
    options.toast_id,
    options.type_,
    options.position,
    options.on_open,
    options.on_close,
    options.auto_close,
    options.close_button,
    transition$1,
    options.hide_progress_bar,
    options.pause_on_hover,
    options.pause_on_focus_loss,
    options.close_on_click,
    options.class_name,
    options.style,
    options.progress_class_name,
    options.draggable,
    options.draggable_percent,
    options.draggable_direction,
    options.container_id,
    options.role,
    options.delay,
    options.on_click,
    options.render,
    options.is_loading,
  );
}

export function hide_progress_bar(options, hide_progress_bar) {
  let hide_progress_bar$1 = new Some(hide_progress_bar);
  return new Options(
    options.toast_id,
    options.type_,
    options.position,
    options.on_open,
    options.on_close,
    options.auto_close,
    options.close_button,
    options.transition,
    hide_progress_bar$1,
    options.pause_on_hover,
    options.pause_on_focus_loss,
    options.close_on_click,
    options.class_name,
    options.style,
    options.progress_class_name,
    options.draggable,
    options.draggable_percent,
    options.draggable_direction,
    options.container_id,
    options.role,
    options.delay,
    options.on_click,
    options.render,
    options.is_loading,
  );
}

export function pause_on_hover(options, pause_on_hover) {
  let pause_on_hover$1 = new Some(pause_on_hover);
  return new Options(
    options.toast_id,
    options.type_,
    options.position,
    options.on_open,
    options.on_close,
    options.auto_close,
    options.close_button,
    options.transition,
    options.hide_progress_bar,
    pause_on_hover$1,
    options.pause_on_focus_loss,
    options.close_on_click,
    options.class_name,
    options.style,
    options.progress_class_name,
    options.draggable,
    options.draggable_percent,
    options.draggable_direction,
    options.container_id,
    options.role,
    options.delay,
    options.on_click,
    options.render,
    options.is_loading,
  );
}

export function pause_on_focus_loss(options, pause_on_focus_loss) {
  let pause_on_focus_loss$1 = new Some(pause_on_focus_loss);
  return new Options(
    options.toast_id,
    options.type_,
    options.position,
    options.on_open,
    options.on_close,
    options.auto_close,
    options.close_button,
    options.transition,
    options.hide_progress_bar,
    options.pause_on_hover,
    pause_on_focus_loss$1,
    options.close_on_click,
    options.class_name,
    options.style,
    options.progress_class_name,
    options.draggable,
    options.draggable_percent,
    options.draggable_direction,
    options.container_id,
    options.role,
    options.delay,
    options.on_click,
    options.render,
    options.is_loading,
  );
}

export function close_on_click(options, close_on_click) {
  let close_on_click$1 = new Some(close_on_click);
  return new Options(
    options.toast_id,
    options.type_,
    options.position,
    options.on_open,
    options.on_close,
    options.auto_close,
    options.close_button,
    options.transition,
    options.hide_progress_bar,
    options.pause_on_hover,
    options.pause_on_focus_loss,
    close_on_click$1,
    options.class_name,
    options.style,
    options.progress_class_name,
    options.draggable,
    options.draggable_percent,
    options.draggable_direction,
    options.container_id,
    options.role,
    options.delay,
    options.on_click,
    options.render,
    options.is_loading,
  );
}

export function class_name(options, class_name) {
  let class_name$1 = new Some(class_name);
  return new Options(
    options.toast_id,
    options.type_,
    options.position,
    options.on_open,
    options.on_close,
    options.auto_close,
    options.close_button,
    options.transition,
    options.hide_progress_bar,
    options.pause_on_hover,
    options.pause_on_focus_loss,
    options.close_on_click,
    class_name$1,
    options.style,
    options.progress_class_name,
    options.draggable,
    options.draggable_percent,
    options.draggable_direction,
    options.container_id,
    options.role,
    options.delay,
    options.on_click,
    options.render,
    options.is_loading,
  );
}

export function style(options, style) {
  let style$1 = new Some(style);
  return new Options(
    options.toast_id,
    options.type_,
    options.position,
    options.on_open,
    options.on_close,
    options.auto_close,
    options.close_button,
    options.transition,
    options.hide_progress_bar,
    options.pause_on_hover,
    options.pause_on_focus_loss,
    options.close_on_click,
    options.class_name,
    style$1,
    options.progress_class_name,
    options.draggable,
    options.draggable_percent,
    options.draggable_direction,
    options.container_id,
    options.role,
    options.delay,
    options.on_click,
    options.render,
    options.is_loading,
  );
}

export function progress_class_name(options, progress_class_name) {
  let progress_class_name$1 = new Some(progress_class_name);
  return new Options(
    options.toast_id,
    options.type_,
    options.position,
    options.on_open,
    options.on_close,
    options.auto_close,
    options.close_button,
    options.transition,
    options.hide_progress_bar,
    options.pause_on_hover,
    options.pause_on_focus_loss,
    options.close_on_click,
    options.class_name,
    options.style,
    progress_class_name$1,
    options.draggable,
    options.draggable_percent,
    options.draggable_direction,
    options.container_id,
    options.role,
    options.delay,
    options.on_click,
    options.render,
    options.is_loading,
  );
}

export function draggable(options, draggable) {
  let draggable$1 = new Some(draggable);
  return new Options(
    options.toast_id,
    options.type_,
    options.position,
    options.on_open,
    options.on_close,
    options.auto_close,
    options.close_button,
    options.transition,
    options.hide_progress_bar,
    options.pause_on_hover,
    options.pause_on_focus_loss,
    options.close_on_click,
    options.class_name,
    options.style,
    options.progress_class_name,
    draggable$1,
    options.draggable_percent,
    options.draggable_direction,
    options.container_id,
    options.role,
    options.delay,
    options.on_click,
    options.render,
    options.is_loading,
  );
}

export function draggable_percent(options, draggable_percent) {
  let draggable_percent$1 = new Some(draggable_percent);
  return new Options(
    options.toast_id,
    options.type_,
    options.position,
    options.on_open,
    options.on_close,
    options.auto_close,
    options.close_button,
    options.transition,
    options.hide_progress_bar,
    options.pause_on_hover,
    options.pause_on_focus_loss,
    options.close_on_click,
    options.class_name,
    options.style,
    options.progress_class_name,
    options.draggable,
    draggable_percent$1,
    options.draggable_direction,
    options.container_id,
    options.role,
    options.delay,
    options.on_click,
    options.render,
    options.is_loading,
  );
}

export function draggable_x(options) {
  let draggable_direction = new Some(new $options.DraggableDirection("x"));
  return new Options(
    options.toast_id,
    options.type_,
    options.position,
    options.on_open,
    options.on_close,
    options.auto_close,
    options.close_button,
    options.transition,
    options.hide_progress_bar,
    options.pause_on_hover,
    options.pause_on_focus_loss,
    options.close_on_click,
    options.class_name,
    options.style,
    options.progress_class_name,
    options.draggable,
    options.draggable_percent,
    draggable_direction,
    options.container_id,
    options.role,
    options.delay,
    options.on_click,
    options.render,
    options.is_loading,
  );
}

export function draggable_y(options) {
  let draggable_direction = new Some(new $options.DraggableDirection("y"));
  return new Options(
    options.toast_id,
    options.type_,
    options.position,
    options.on_open,
    options.on_close,
    options.auto_close,
    options.close_button,
    options.transition,
    options.hide_progress_bar,
    options.pause_on_hover,
    options.pause_on_focus_loss,
    options.close_on_click,
    options.class_name,
    options.style,
    options.progress_class_name,
    options.draggable,
    options.draggable_percent,
    draggable_direction,
    options.container_id,
    options.role,
    options.delay,
    options.on_click,
    options.render,
    options.is_loading,
  );
}

export function container_id(options, container_id) {
  let container_id$1 = new Some(container_id);
  return new Options(
    options.toast_id,
    options.type_,
    options.position,
    options.on_open,
    options.on_close,
    options.auto_close,
    options.close_button,
    options.transition,
    options.hide_progress_bar,
    options.pause_on_hover,
    options.pause_on_focus_loss,
    options.close_on_click,
    options.class_name,
    options.style,
    options.progress_class_name,
    options.draggable,
    options.draggable_percent,
    options.draggable_direction,
    container_id$1,
    options.role,
    options.delay,
    options.on_click,
    options.render,
    options.is_loading,
  );
}

export function role(options, role) {
  let role$1 = new Some(role);
  return new Options(
    options.toast_id,
    options.type_,
    options.position,
    options.on_open,
    options.on_close,
    options.auto_close,
    options.close_button,
    options.transition,
    options.hide_progress_bar,
    options.pause_on_hover,
    options.pause_on_focus_loss,
    options.close_on_click,
    options.class_name,
    options.style,
    options.progress_class_name,
    options.draggable,
    options.draggable_percent,
    options.draggable_direction,
    options.container_id,
    role$1,
    options.delay,
    options.on_click,
    options.render,
    options.is_loading,
  );
}

export function delay(options, delay) {
  let delay$1 = new Some(delay);
  return new Options(
    options.toast_id,
    options.type_,
    options.position,
    options.on_open,
    options.on_close,
    options.auto_close,
    options.close_button,
    options.transition,
    options.hide_progress_bar,
    options.pause_on_hover,
    options.pause_on_focus_loss,
    options.close_on_click,
    options.class_name,
    options.style,
    options.progress_class_name,
    options.draggable,
    options.draggable_percent,
    options.draggable_direction,
    options.container_id,
    options.role,
    delay$1,
    options.on_click,
    options.render,
    options.is_loading,
  );
}

export function on_click(options, on_click) {
  let on_click$1 = new Some(on_click);
  return new Options(
    options.toast_id,
    options.type_,
    options.position,
    options.on_open,
    options.on_close,
    options.auto_close,
    options.close_button,
    options.transition,
    options.hide_progress_bar,
    options.pause_on_hover,
    options.pause_on_focus_loss,
    options.close_on_click,
    options.class_name,
    options.style,
    options.progress_class_name,
    options.draggable,
    options.draggable_percent,
    options.draggable_direction,
    options.container_id,
    options.role,
    options.delay,
    on_click$1,
    options.render,
    options.is_loading,
  );
}

export function render(options, render) {
  let render$1 = new Some(render);
  return new Options(
    options.toast_id,
    options.type_,
    options.position,
    options.on_open,
    options.on_close,
    options.auto_close,
    options.close_button,
    options.transition,
    options.hide_progress_bar,
    options.pause_on_hover,
    options.pause_on_focus_loss,
    options.close_on_click,
    options.class_name,
    options.style,
    options.progress_class_name,
    options.draggable,
    options.draggable_percent,
    options.draggable_direction,
    options.container_id,
    options.role,
    options.delay,
    options.on_click,
    render$1,
    options.is_loading,
  );
}

export function is_loading(options, is_loading) {
  let is_loading$1 = new Some(is_loading);
  return new Options(
    options.toast_id,
    options.type_,
    options.position,
    options.on_open,
    options.on_close,
    options.auto_close,
    options.close_button,
    options.transition,
    options.hide_progress_bar,
    options.pause_on_hover,
    options.pause_on_focus_loss,
    options.close_on_click,
    options.class_name,
    options.style,
    options.progress_class_name,
    options.draggable,
    options.draggable_percent,
    options.draggable_direction,
    options.container_id,
    options.role,
    options.delay,
    options.on_click,
    options.render,
    is_loading$1,
  );
}
